module.exports = __webpack_public_path__ + "static/media/light-r-4.42e1e2b2.png";